import React from 'react';
import { Tab, Menu, Label } from 'semantic-ui-react';
import _ from 'lodash';
import { dispatch } from '@rematch/core';
import CommonTable from '../../../drive/Table/TableLayout'
import userListJson from './userListJson';
import InvitedUserListJson from './InvitedUserListJson'
import UserCache from "../../../../helpers/cache/userCache";
import { toastr } from 'react-redux-toastr';
var moment = require('moment');
export default class Users extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 1,
            tableHeader: userListJson,
            _sort: "createdAt",
            _limit: 10,
            userData: null,
            accountUserData: {
            CustomerAdmin: [],
            User: []
        }
        }
    }

    async componentWillMount() {
        dispatch.account.getInviteByAccountIdAsync(this.props.selectedAccount._id)
        dispatch.account.selectAccount({ accountId : this.props.selectedAccount._id });
        const accountUserData = {
            CustomerAdmin: [],
            User: []
        }
        accountUserData.CustomerAdmin = this.props.selectedAccount.users.filter(user => user.role === "customerAdmin").map(user => user.id);
        accountUserData.User = this.props.selectedAccount.users.filter(user => user.role === "user").map(user => user.id);
        this.setState({
            accountUserData: accountUserData,
            userData: accountUserData.User
        })
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.accountInvitedUser) {
            if (nextProps.accountInvitedUser.length !== this.props.accountInvitedUser.length) {
                this.getInvitationData()
            }
        }
        if (this.props.selectedAccount){
            if(nextProps.selectedAccount.length !== this.props.selectedAccount.length) {
                const accountUserData = {
                        CustomerAdmin: [],
                        User: []
                    }
                accountUserData.CustomerAdmin = nextProps.selectedAccount.users.filter(user => user.role === "customerAdmin").map(user => user.id);
                accountUserData.User = nextProps.selectedAccount.users.filter(user => user.role === "user").map(user => user.id);
                this.setState({
                    accountUserData: accountUserData,
                    userData: accountUserData.User
                })
            }
        }
    }

    componentDidMount() {
        if (this.props.match.params && this.props.match.params.activeIndex) {
            if (this.props.match.params.activeIndex === 0 || this.props.match.params.activeIndex === 1) {
                this.setState({ tableHeader: userListJson })
            } else {
                this.setState({ tableHeader: InvitedUserListJson })
            }

            this.localSetState(Number(this.props.match.params.activeIndex));
        } else {
            this.localSetState(1)
            this.setState({ tableHeader: userListJson, })
        }
    }

    localSetState = async (activeIndex) => {
        this.setState({ activeIndex: activeIndex })
        if (activeIndex === 0) {
            this.setState({
                userData: this.state.accountUserData.CustomerAdmin,
                tableHeader: userListJson,
                _sort: "firstName",
            })
        } else if (activeIndex === 1) {
            this.setState({
                userData: this.state.accountUserData.User,
                tableHeader: userListJson,
                _sort: "firstName",
            })
        }
        else if (activeIndex === 2) {
            this.getInvitationData()
        }
    }

    getInvitationData = async () => {
        await dispatch.account.getInviteByAccountIdAsync(this.props.selectedAccount._id)
        this.setState({
            tableHeader: InvitedUserListJson,
            _sort: "createdAt",
        })
        let invitedUsers = this.filterInvitedUsers()
        this.setState({
            userData: invitedUsers,
        })
    }

    filterInvitedUsers = () => {
        let invitedUsers = []
        if (this.props.accountInvitedUser && this.props.accountInvitedUser.length !== 0) {
            for (let i = 0; i < this.props.accountInvitedUser.length; i++) {
                if (this.props.accountInvitedUser[i].referenceId) {
                    let expiryTime = moment.duration(moment().diff(moment(this.props.accountInvitedUser[i].updatedAt))).asHours() < 72;
                    this.props.accountInvitedUser[i].referenceName = this.props.accountInvitedUser[i].referenceId.name;
                    if(this.props.accountInvitedUser[i].isDeclined) {
                        this.props.accountInvitedUser[i].isActive = false
                    }
                    else {
                        this.props.accountInvitedUser[i].isActive = expiryTime;
                    }
                    invitedUsers.push(this.props.accountInvitedUser[i]);
                }

            }
        }
        return invitedUsers;
    }

    handleTabChange = (e, data) => {
        this.setState({ activeIndex: data.activeIndex })
        this.localSetState(data.activeIndex)
    }

    addColumn = (newColumns) => {
        if (newColumns) {
            this.setState({ tableHeader: newColumns })
        }
    };

    handleDropDownItem = (event, type, data, clickedCount) => {
        if (type.text === "Resend") {
            this.resendInvitation(event, data)
        }
        if (type.text === "Delete") {
            this.deleteInvitaion(event, data)
        }
        if (type.text === "View") { }
    }

    resendInvitation(event, invite) {
        let message = <div className="confirmMessage">
            <h3>Resend Invitation</h3>
            <label>{invite.email}</label>
            <p>Are you sure that you wish to resend this invitation?</p>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                let organizationObj = {
                    "name": invite.referenceId.name
                }
                let emailObject = {
                    templateName: "resendInviteMail",
                    toEmail: invite.email,
                    invite: invite,
                    invitationCode: invite._id,
                    fromUser: this.props.user,
                    organization: organizationObj,
                    subject: `You have been Invited to join the "${invite.referenceId.name}" account on Aspenify platform.`
                }
                dispatch.invite.resendInvitation(emailObject);
                this.getInvitationData()
            }
        });
    }

    async deleteInvitaion(event, invite) {
        let message = <div className="confirmMessage">
            <h3>Delete Invitation</h3>
            <label>{invite.firstName} {invite.lastName}</label>
            <p>Are you sure that you wish to delete this invitation?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: async () => {
                await dispatch.invite.deleteInvitaionAsync(invite);
                this.getInvitationData()
            }
        });
    }

    render() {
        const { activeIndex, tableHeader } = this.state;
        const invitedUsers = this.filterInvitedUsers()

        let table = <CommonTable
            tableName={null}
            tableHeader={tableHeader}
            listData={this.state.userData}
            searchable={false}
            limit={this.state._limit}
            sort={this.state._sort}
            selection={true}
            totalCount={this.state.userData && this.state.userData.length}
            loading={false}
            addColumn={this.addColumn}
            handleDropDownItem={this.handleDropDownItem}
            handleTableComponent={this.handleTableComponent}
            activeIndex={activeIndex}
        />

        const panes = [
            {
                menuItem: <Menu.Item key='Owners'>
                    Account Owners <Label>{this.state.accountUserData.CustomerAdmin.length}</Label>
                </Menu.Item>, render: () => table
            }, {
                menuItem: <Menu.Item key='Users'>
                    Account Users{this.state.accountUserData.User ? <Label>{this.state.accountUserData.User.length}</Label> : ''}
                </Menu.Item>, render: () => table
            }, {
                menuItem: <Menu.Item key='Invitations' disabled={!this.props.accountInvitedUser}>
                    Invitations{this.props.accountInvitedUser ? <Label>{invitedUsers.length}</Label> : ''}
                </Menu.Item>, render: () => table
            },
        ]

        return (
            <Tab
                style={{ padding: 0 }}
                menu={{ secondary: true, pointing: true }}
                panes={panes}
                activeIndex={activeIndex}
                onTabChange={this.handleTabChange}
                className="three-block" />
        );
    }
}
